import { EventCalendarList, Utils } from "Components";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import { ActionSection } from "Styles";
import { theme } from "Theme";
import voca from "voca";

const slug = require("slug");
slug.defaults.modes["pretty"] = {
  replacement: "",
  symbols: true,
  remove: /[.]/g,
  lower: true,
  charmap: slug.charmap,
  multicharmap: slug.multicharmap,
};

const BlankWrapper = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0;
  max-width: 100%;
  padding: 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }

  @media (min-width: ${theme.breakpoints.m}) {
  }

  @media (min-width: ${theme.breakpoints.l}) {
  }
`;

const Grid = styled.div`
  display: ${(props) => (props.featured ? "block;" : "grid;")};
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(33%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  }
  grid-gap: 16px;
`;

class EventsFrame extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentModal: null,
      selectedRegion: "ALL",
      selectedBrand: "ALL",
      selectedMonth: "ALL",
      shareEvent: null,
      showEvents: false,
      isActive: false,
    };
    this.onSelectBrandChange = this.onSelectBrandChange.bind(this);
    this.onSelectRegionChange = this.onSelectRegionChange.bind(this);
    this.onSelectMonthChange = this.onSelectMonthChange.bind(this);
    this.onResetFilters = this.onResetFilters.bind(this);
  }

  componentDidMount() {
    this.setState({
      show: this.props.show ? this.props.show : 999,
      currentModal: null,
      selectedBrand: "ALL",
      selectedRegion: "ALL",
      selectedMonth: this.props.now ? moment().format("MMM") : "ALL",
      shareEvent: null,
      showEvents: false,
    });
  }

  toggleModal = (key, param) => (e) => {
    e.preventDefault();
    if (this.state.currentModal) {
      this.handleModalCloseRequest();
      return;
    }

    this.setState({
      ...this.state,
      currentModal: key,
      shareEvent: param.shareEvent,
      showEvents: param.showEvents,
    });
  };

  handleModalCloseRequest = () => {
    this.setState({
      ...this.state,
      currentModal: null,
    });
  };

  handleOnAfterOpenModal = () => {};

  onSelectRegionChange(e) {
    this.setState({
      selectedRegion: e.target.value,
      isActive: !this.state.isActive,
    });
  }

  onSelectBrandChange(e) {
    this.setState({
      selectedBrand: e.target.value,
      selectedMonth: "ALL",
      isActive: !this.state.isActive,
    });
  }

  onSelectMonthChange(e) {
    // console.log(this.state)
    this.setState({ selectedMonth: e.target.value });
  }

  onResetFilters() {
    this.setState({
      selectedRegion: "ALL",
      selectedBrand: "ALL",
      selectedMonth: "ALL",
    });
  }

  render() {
    const { track, countdown, featured, big, events } = this.props;
    const activeBrands = [];

    events.forEach((node) => {
      if (node.eventType === "gala" || node.eventType === "camp") {
        node.eventType = "conference";
      } else {
        node.eventType = voca.lowerCase(node.eventType);
      }
      node.month = slug(moment(node.date).format("MMM"));
    });

    events.map((data) => {
      if (activeBrands.indexOf(data.node.brand) === -1) {
        activeBrands.push(data.node.brand);
      }
    });

    let show = Utils.getUrlParam("show") || 999;
    let filteredBrands = events.slice(0, show);

    return (
      <BlankWrapper>
        <ActionSection>
          <Grid featured={featured}>
            <>
              {filteredBrands.map((data) => {
                let event = data.node;
                return <EventCalendarList className={"EventCalendarList"} featured={featured} big={big} countdown={countdown} key={event.id} node={event} track={track} />;
              })}
            </>
          </Grid>
        </ActionSection>
      </BlankWrapper>
    );
  }
}

export default EventsFrame;
